"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityFactory = void 0;
var tslib_1 = require("tslib");
var ManagedFactory_1 = require("./ManagedFactory");
var intersection_1 = require("../intersection");
var EntityFactory = /** @class */ (function (_super) {
    tslib_1.__extends(EntityFactory, _super);
    function EntityFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a new instance of the factory type
     *
     * @param args Constructor arguments used for instantiation, the constructor will not be called
     * when no arguments are passed
     * @return A new created instance of T
     */
    EntityFactory.prototype.newInstance = function (args) {
        var instance = _super.prototype.newInstance.call(this, args);
        intersection_1.Metadata.get(instance).db = this.db;
        return instance;
    };
    /**
     * Loads the instance for the given id, or null if the id does not exists.
     * @param id The id to query
     * @param [options] The load options
     * @param [options.depth=0] The object depth which will be loaded. Depth 0 loads only this object,
     * <code>true</code> loads the objects by reachability.
     * @param [options.refresh=false] Indicates whether the object should be revalidated (cache bypass).
     * @param [options.local=false] Indicates whether the local copy (from the entity manager)
     * of an object should be returned if it exists. This value might be stale.
     * @param doneCallback Called when the operation succeed.
     * @param failCallback Called when the operation failed.
     * @return A Promise that will be fulfilled when the asynchronous operation completes.
     */
    EntityFactory.prototype.load = function (id, options, doneCallback, failCallback) {
        if (typeof options === 'function') {
            return this.load(id, {}, options, doneCallback);
        }
        return this.db.load(this.managedType.typeConstructor, id, options).then(doneCallback, failCallback);
    };
    /**
     * Gets an unloaded reference for the given id.
     * @param id The id of an object to get a reference for.
     * @return An unloaded reference to the object with the given id.
     */
    EntityFactory.prototype.ref = function (id) {
        return this.db.getReference(this.managedType.ref, id);
    };
    /**
     * Creates a new instance and sets the DatabaseObject to the given json
     * @param json
     * @return instance
     */
    EntityFactory.prototype.fromJSON = function (json) {
        var obj = this.db.getReference(this.managedType.ref, json.id);
        return this.managedType.fromJsonValue(intersection_1.Metadata.get(obj), json, obj, { persisting: false });
    };
    /**
     * Creates a new query for this class
     * @return The query builder
     */
    EntityFactory.prototype.find = function () {
        return this.db.createQueryBuilder(this.managedType.typeConstructor);
    };
    /**
     * Creates a new partial update for this class
     * @param id The id to partial update
     * @param [partialUpdate] An initial partial update to execute
     * @return A partial update builder for the given entity id
     */
    EntityFactory.prototype.partialUpdate = function (id, partialUpdate) {
        return this.ref(id).partialUpdate(partialUpdate);
    };
    /**
     * Executes a raw query for this class if the bucket supports it.
     * @param query The query to be executed
     * @param triggeredBy Who or what triggered this query
     */
    EntityFactory.prototype.executeQuery = function (query, triggeredBy) {
        return this.db.executeQuery(this.managedType.typeConstructor, query, triggeredBy);
    };
    return EntityFactory;
}(ManagedFactory_1.ManagedFactory));
exports.EntityFactory = EntityFactory;
//# sourceMappingURL=data:application/json;base64,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